import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface ClosingSummaryLineProps {
  label: string;
  value: string;
}

/**
 * One figure of a ปิดศูนย์เซล branch-day, label left and value right.
 *
 * Shared by the supervisor's live ยอดค่าใช้จ่าย (DIP) preview and the recorded outcome the
 * whole review cohort reads, so the figure a day was signed on is laid out exactly as it was
 * while it was being keyed in.
 */
export default function ClosingSummaryLine({
  label,
  value,
}: ClosingSummaryLineProps) {
  return (
    <Stack direction="row" justifyContent="space-between" gap={2}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600}>
        {value}
      </Typography>
    </Stack>
  );
}
